import {SimpleTreeView} from "@mui/x-tree-view/SimpleTreeView";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import React from "react";
import {MinusSquare, PlusSquare} from "../../../components/UI/icons/IconsComponents";
import {SETTINGS_TYPES} from "../../../data/SettingsType";
import {isKuhniVersoMebelDomain, KUHNI_HIDDEN_CUSTOMER_SETTINGS} from "../../../utils/isKuhniVersoMebelDomain";

const TreeViewSettings = ({
                              activeSetting,
                              expandedItems,
                              handleExpandedItemsChange,
                              handleActiveItemsChange,
                              userRoles,
                              stage
                          }) => {
    const isKuhniVersoMebel = isKuhniVersoMebelDomain();

    return <SimpleTreeView
        sx={{direction: "ltr"}}
        aria-label="customized"
        selectedItems={[activeSetting]}
        expandedItems={expandedItems}
        onExpandedItemsChange={handleExpandedItemsChange}
        onItemClick={(e, itemId) => handleActiveItemsChange(itemId)}
        slots={{
            expandIcon: PlusSquare,
            collapseIcon: MinusSquare,
        }}>
        <TreeItem itemId="profile" label={SETTINGS_TYPES.profile}/>
        {userRoles.type !== "admin" && <TreeItem itemId="personalization" label={SETTINGS_TYPES.personalization}/>}
        {userRoles.type === "admin" && <TreeItem itemId="settings" label={userRoles.name}>
            <TreeItem itemId="userRolesSettings" label={SETTINGS_TYPES.userRolesSettings}>
                <TreeItem itemId={"userRoles"} label={SETTINGS_TYPES.userRoles}></TreeItem>
            </TreeItem>
            <TreeItem itemId="allUsersSettings" label={SETTINGS_TYPES.allUsersSettings}>
                <TreeItem itemId={"allOrganizations"} label={SETTINGS_TYPES.allOrganizations}></TreeItem>
                <TreeItem itemId={"allCustomers"} label={SETTINGS_TYPES.allCustomers}></TreeItem>
                <TreeItem itemId={"allUsers"} label={SETTINGS_TYPES.allUsers}></TreeItem>
            </TreeItem>
            <TreeItem itemId="adminMaterialSettings" label={SETTINGS_TYPES.adminMaterialSettings}>
                <TreeItem itemId="adminMaterialGroups" label={SETTINGS_TYPES.adminMaterialGroups}/>
                <TreeItem itemId="adminMaterial" label={SETTINGS_TYPES.adminMaterial}/>
                <TreeItem itemId="adminImports" label={SETTINGS_TYPES.adminImports}/>
                <TreeItem itemId="adminExports" label={SETTINGS_TYPES.adminExports}/>
            </TreeItem>
            <TreeItem itemId="jobSettings" label={SETTINGS_TYPES.jobSettings}>
                <TreeItem itemId="listJobPacking" label={SETTINGS_TYPES.listJobPacking}/>
                <TreeItem itemId="listJobMilling" label={SETTINGS_TYPES.listJobMilling}/>
                <TreeItem itemId="listJobEdge" label={SETTINGS_TYPES.listJobEdge}/>
                <TreeItem itemId="listJobDrilling" label={SETTINGS_TYPES.listJobDrilling}/>
                <TreeItem itemId="listJobCutting" label={SETTINGS_TYPES.listJobCutting}/>
            </TreeItem>
            <TreeItem itemId="samplesSettings" label={SETTINGS_TYPES.samplesSettings}>
                <TreeItem itemId="systemSamples" label={SETTINGS_TYPES.systemSamples}/>
                <TreeItem itemId="systemSamplesGroup" label={SETTINGS_TYPES.systemSamplesGroup}/>
                <TreeItem itemId="systemSamplesEdges" label={SETTINGS_TYPES.systemSamplesEdges}/>
            </TreeItem>
            <TreeItem itemId="currencySettings" label={SETTINGS_TYPES.currencySettings}>
                <TreeItem itemId={"currency"} label={SETTINGS_TYPES.currency}></TreeItem>
                <TreeItem itemId={"currenciesNationalBank"} label={SETTINGS_TYPES.currenciesNationalBank}></TreeItem>
            </TreeItem>
            <TreeItem itemId="adminSuppliersSettings" label={SETTINGS_TYPES.adminSuppliersSettings}>
                <TreeItem itemId={"adminSuppliers"} label={SETTINGS_TYPES.adminSuppliers}></TreeItem>
            </TreeItem>
            <TreeItem itemId="adminManufacturerSettings" label={SETTINGS_TYPES.adminManufacturerSettings}>
                <TreeItem itemId={"adminManufacturer"} label={SETTINGS_TYPES.adminManufacturer}></TreeItem>
            </TreeItem>
            <TreeItem itemId="unitSettings" label={SETTINGS_TYPES.unitSettings}>
                <TreeItem itemId={"unit"} label={SETTINGS_TYPES.unit}></TreeItem>
            </TreeItem>
            <TreeItem itemId="ratingSettings" label={SETTINGS_TYPES.ratingSettings}>
                <TreeItem itemId={"rating"} label={SETTINGS_TYPES.rating}></TreeItem>
            </TreeItem>
            <TreeItem itemId="vacancySettings" label={SETTINGS_TYPES.vacancySettings}>
                <TreeItem itemId={"vacancy"} label={SETTINGS_TYPES.vacancy}></TreeItem>
            </TreeItem>
            <TreeItem itemId="helpSettings" label={SETTINGS_TYPES.helpSettings}>
                <TreeItem itemId="themeHelp" label={SETTINGS_TYPES.themeHelp}/>
                <TreeItem itemId="help" label={SETTINGS_TYPES.help}/>
            </TreeItem>
            <TreeItem itemId="newsSettings" label={SETTINGS_TYPES.newsSettings}>
                <TreeItem itemId="themeNews" label={SETTINGS_TYPES.themeNews}/>
                <TreeItem itemId="news" label={SETTINGS_TYPES.news}/>
            </TreeItem>
            <TreeItem itemId="promotionSettings" label={SETTINGS_TYPES.promotionSettings}>
                <TreeItem itemId="themePromotion" label={SETTINGS_TYPES.themePromotion}/>
                <TreeItem itemId="promotion" label={SETTINGS_TYPES.promotion}/>
            </TreeItem>
            <TreeItem itemId="pictureSettings" label={SETTINGS_TYPES.pictureSettings}>
                <TreeItem itemId={"picture"} label={SETTINGS_TYPES.picture}></TreeItem>
            </TreeItem>
            <TreeItem itemId="filesSettings" label={SETTINGS_TYPES.filesSettings}>
                <TreeItem itemId={"files"} label={SETTINGS_TYPES.files}></TreeItem>
                <TreeItem itemId={"folders"} label={SETTINGS_TYPES.folders}></TreeItem>
            </TreeItem>
            <TreeItem itemId="errorsSettings" label={SETTINGS_TYPES.errorsSettings}>
                <TreeItem itemId={"errors"} label={SETTINGS_TYPES.errors}></TreeItem>
            </TreeItem>
            <TreeItem itemId="cache" label={SETTINGS_TYPES.cache}>
                <TreeItem itemId={"cacheOrders"} label={SETTINGS_TYPES.cacheOrders}></TreeItem>
                <TreeItem itemId={"cacheModels"} label={SETTINGS_TYPES.cacheModels}></TreeItem>
                <TreeItem itemId={"cacheAuthorization"} label={SETTINGS_TYPES.cacheAuthorization}></TreeItem>
            </TreeItem>

        </TreeItem>}
        {userRoles.type === "organization" &&
            <TreeItem itemId="settings" label={userRoles.name}>
                {stage !== 1 && <TreeItem itemId="generalSettings" label={SETTINGS_TYPES.generalSettings}/>}
                {stage < 9 && <TreeItem itemId="setupStages" label={SETTINGS_TYPES.setupStages}/>}
                {stage > 3 && <TreeItem itemId="warehouseSettings" label={SETTINGS_TYPES.warehouseSettings}>
                    <TreeItem itemId="warehouseName" label={SETTINGS_TYPES.warehouseName}/>
                    {stage > 7 && <>
                        <TreeItem itemId="materialGroups" label={SETTINGS_TYPES.materialGroups}/>
                        <TreeItem itemId="material" label={SETTINGS_TYPES.material}/>
                        <TreeItem itemId="imports" label={SETTINGS_TYPES.imports}/>
                        <TreeItem itemId="exports" label={SETTINGS_TYPES.exports}/>
                    </>}

                </TreeItem>}
                {stage > 5 && <TreeItem itemId="jobSettings" label={SETTINGS_TYPES.jobSettings}>
                    <TreeItem itemId="listJob" label={SETTINGS_TYPES.listJob}/>
                    <TreeItem itemId="listJobName" label={SETTINGS_TYPES.listJobName}/>
                    <TreeItem itemId="listTypeJob" label={SETTINGS_TYPES.listTypeJob}/>
                    <TreeItem itemId="importJob" label={SETTINGS_TYPES.importJob}/>
                </TreeItem>}
                {stage > 5 && <TreeItem itemId="orderSettings" label={SETTINGS_TYPES.orderSettings}>
                    <TreeItem itemId="headers" label={SETTINGS_TYPES.headers}/>
                    {stage > 6 && <TreeItem itemId="attributes" label={SETTINGS_TYPES.attributes}/>}
                </TreeItem>}
                {stage > 7 && <TreeItem itemId="workerSettings" label={SETTINGS_TYPES.workerSettings}>
                    <TreeItem itemId="workers" label={SETTINGS_TYPES.workers}/>
                </TreeItem>}
                {stage > 7 && <TreeItem itemId="organizationCustomersSettings"
                                        label={SETTINGS_TYPES.organizationCustomersSettings}>
                    <TreeItem itemId="organizationCustomers" label={SETTINGS_TYPES.organizationCustomers}/>
                </TreeItem>}
                {stage > 5 && <TreeItem itemId="organizationSuppliersSettings"
                                        label={SETTINGS_TYPES.organizationSuppliersSettings}>
                    <TreeItem itemId="organizationSuppliers" label={SETTINGS_TYPES.organizationSuppliers}/>
                </TreeItem>}
                {stage > 7 && <TreeItem itemId="optimizationSettings" label={SETTINGS_TYPES.optimizationSettings}>
                    <TreeItem itemId="rulesModifyingOptimization" label={SETTINGS_TYPES.rulesModifyingOptimization}/>
                </TreeItem>}
                {stage > 7 && <TreeItem itemId="reserveSettings" label={SETTINGS_TYPES.reserveSettings}>
                    <TreeItem itemId="edgeReserveSettings" label={SETTINGS_TYPES.edgeReserveSettings}/>
                </TreeItem>}
                {stage > 7 && <TreeItem itemId="CNCSettings" label={SETTINGS_TYPES.CNCSettings}>
                    <TreeItem itemId="CuttingSettings" label={SETTINGS_TYPES.CuttingSettings}>
                        <TreeItem itemId="BiesseSettings" label={SETTINGS_TYPES.BiesseSettings}>
                            <TreeItem itemId="selcoFileFields" label={SETTINGS_TYPES.selcoFileFields}/>
                        </TreeItem>
                    </TreeItem>
                    <TreeItem itemId="MillingDrillingSettings" label={SETTINGS_TYPES.MillingDrillingSettings}>
                        <TreeItem itemId="machines" label={SETTINGS_TYPES.machines}/>
                        <TreeItem itemId="postprocessors" label={SETTINGS_TYPES.postprocessors}/>
                    </TreeItem>
                </TreeItem>}

                <TreeItem itemId="adress" label={SETTINGS_TYPES.adress}>
                    <TreeItem itemId="addressList" label={SETTINGS_TYPES.addressList}/>
                </TreeItem>
                {stage > 7 && <TreeItem itemId="modelSettings" label={SETTINGS_TYPES.modelSettings}>
                    <TreeItem itemId="packagingUnits" label={SETTINGS_TYPES.packagingUnits}/>
                    <TreeItem itemId="packagingSets" label={SETTINGS_TYPES.packagingSets}/>
                    <TreeItem itemId="detailModels" label={SETTINGS_TYPES.detailModels}/>
                    <TreeItem itemId="modelEdges" label={SETTINGS_TYPES.modelEdges}/>
                    <TreeItem itemId="basicModels" label={SETTINGS_TYPES.basicModels}/>
                    <TreeItem itemId="models" label={SETTINGS_TYPES.models}/>
                    <TreeItem itemId="importModels" label={SETTINGS_TYPES.importModels}/>
                </TreeItem>}
                <TreeItem itemId="compositionSettings" label={SETTINGS_TYPES.compositionSettings}>
                    <TreeItem itemId="composition" label={SETTINGS_TYPES.composition}/>
                    <TreeItem itemId="modules" label={SETTINGS_TYPES.modules}/>
                    <TreeItem itemId="moduleDetails" label={SETTINGS_TYPES.moduleDetails}/>
                    <TreeItem itemId="compositionEdges" label={SETTINGS_TYPES.compositionEdges}/>
                    <TreeItem itemId="compositionMedia" label={SETTINGS_TYPES.compositionMedia}/>
                    <TreeItem itemId="compositionPictures" label={SETTINGS_TYPES.compositionPictures}/>
                    <TreeItem itemId="compositionTextures" label={SETTINGS_TYPES.compositionTextures}/>
                </TreeItem>
            </TreeItem>}

        {userRoles.type === "customer" && <TreeItem itemId="settings" label={userRoles.name}>
            {!isKuhniVersoMebel && <TreeItem itemId="relatedUsers" label={SETTINGS_TYPES.relatedUsers}></TreeItem>}
            {!isKuhniVersoMebel &&
                <TreeItem itemId="favorite-organization" label={SETTINGS_TYPES["favorite-organization"]}></TreeItem>}
            <TreeItem itemId="customerSettings" label={SETTINGS_TYPES.customerSettings}></TreeItem>
            <TreeItem itemId="adress" label={SETTINGS_TYPES.adress}>
                <TreeItem itemId="addressList" label={SETTINGS_TYPES.addressList}/>
            </TreeItem>
        </TreeItem>}


    </SimpleTreeView>
}
export default TreeViewSettings